import { useState, useEffect } from "react";
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import HeaqderNav from "../components/HeaqderNav";
import MonthlyPaymentButton from "../components/MonthlyPaymentButton";
import YearlyPaymentButton from "../components/YearlyPaymentButton";
import CancelSubscriptionBtn from "../components/CancelSubscriptionBtn";
import { membershipList, imgPath, nearExpiry, isExpiry, nearExpiry90 } from "../App";

const Payment = () => {
  const storedData = sessionStorage.getItem("jacUserCore");
  const [userInfo, setUserInfo] = useState({});
  const [done, setDone] = useState(undefined);
  const [plan, setPlan] = useState('yearly');
  const [isLoading, setIsLoading] = useState(false);

  const payments = {
    paypal_subscription: 'PayPal（年間サブスクリプション）',
    end_paypal_subscription: 'PayPal（年間サブスクリプションキャンセル済）',
    paypal: `PayPal`,
    bank_transfer: `銀行振込`,
    check: `小切手`,
    cash: `現金払い`,
    gcash: `GCash`,
  }

  const getPaymentMethod = () => {
    return userInfo.paymentMethod ? payments[userInfo.paymentMethod] : `-`;
  }


  useEffect(() => {
    const handlePopState = () => {
      if (isLoading) {
        // 戻る操作をキャンセル
        window.history.pushState(null, "", window.location.href);
        alert("処理中は戻れません");
      }
    };

    if (isLoading) {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopState);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isLoading]);

  useEffect(() => {
    if (storedData) {
      try {
        setUserInfo(JSON.parse(storedData));
      } catch (e) {
        console.error("❌ JSON parse error:", e);
      }
    }
  }, []);


  const changePlan = (e) => {
    const plan = e.target.value;
    setPlan(prev => (plan));
  };

  const showPayment = () => {
    if (userInfo.membership === `individual`) {
      if ((isExpiry(userInfo.expiry) || nearExpiry90(userInfo.expiry))) return true;
    } else {
      if ((isExpiry(userInfo.expiry) || nearExpiry(userInfo.expiry))) return true;
    }
    return false
  };

  console.log(userInfo?.paymentMethod)
  console.log(!isExpiry(userInfo.expiry) && userInfo?.paymentMethod === "paypal_subscription" && done === undefined)

  return (
    <>
      <HeaqderNav />
      <ul className="breadcrumb">
        <li>お支払い</li>
      </ul>
      <dl className="dl">
        <dt>会員ID</dt>
        <dd>{userInfo.id}</dd>
      </dl>
      <h2>会員区分</h2>
      <dl className="dl">
        <dt>種別</dt>
        <dd>{userInfo.membership === `invalid` ? `-` : membershipList[userInfo.membership]}</dd>
      </dl>
      <h2>支払い情報</h2>
      <dl className="dl">
        <dt>有効期限</dt>
        <dd>{userInfo.expiry}</dd>
        <dt>ステータス</dt>
        <dd>{userInfo.membership === `invalid` || isExpiry(userInfo.expiry) ? `失効` : `有効`}</dd>
        <dt>最終支払日</dt>
        <dd>{userInfo.paymentDate || '-'}</dd>
        <dt>支払方法</dt>
        <dd>
          {getPaymentMethod()}
          {userInfo.paymentMethod === `end_paypal_subscription` && <p><small>※{userInfo.expiry}でメンバーシップの有効期限は終わりますが、期限一ヶ月前よりメンバーシップの再購入が可能です。</small></p>}
        </dd>
      </dl>
      {(showPayment()) &&

        (<>
          <h2>支払い</h2>
          {!isLoading &&
            <>
              <FormControl component="fieldset">
                <FormLabel component="legend">会員種目</FormLabel>
                {userInfo.status === `SAVED` ? userInfo.plan :
                  <RadioGroup
                    row
                    name="membershipType"
                    value={plan || ""}
                    onChange={changePlan}
                  >
                    <FormControlLabel
                      value="yearly"
                      control={<Radio />}
                      label="個人会員(年単位支払/自動更新)※1"
                    />
                    <FormControlLabel
                      value="monthly"
                      control={<Radio />}
                      label="賛助会員(月単位支払)※2"
                    />
                  </RadioGroup>
                }
              </FormControl>
              <ol>
                <li><small><strong>個人会員（年会員/自動更新）</strong>：セブ日本人会の個人正会員として登録され、総会への参加権と議決権を持ちます。</small></li>
                <li><small><strong>賛助会員（月会員）</strong>：セブ日本人会の賛助会員として登録され、総会への参加権と議決権はありませんが、優待施設での利用は可能です。</small></li>

              </ol>
            </>}
          {plan === "monthly" && userInfo?.id ? (
            <>
              {/* 処理していない場合 */}
              {((done === undefined || done === `failed`) && !isLoading) && <MonthlyPaymentButton setUserInfo={setUserInfo} userInfo={userInfo} setDone={setDone} setIsLoading={setIsLoading} />}
            </>
          ) : <>
            {/* 処理していない場合 */}
            {((done === undefined || done === `failed`) && !isLoading) && <YearlyPaymentButton setUserInfo={setUserInfo} userInfo={userInfo} setDone={setDone} setIsLoading={setIsLoading} />}
          </>}
        </>)
      }
      <PaymentDone done={done} userInfo={userInfo} setUserInfo={setUserInfo} />
      {!isExpiry(userInfo.expiry) && userInfo?.paymentMethod === "paypal_subscription" && done === undefined && <CancelSubscriptionBtn done={done} userInfo={userInfo} setUserInfo={setUserInfo} setIsLoading={setIsLoading} setDone={setDone} isLoading={isLoading} />}
      {isLoading && <div className="register"><img src={`${imgPath}/images/spinner.svg`} alt="" width={100} height={110} /></div>}
    </>
  );
};

export default Payment;

const PaymentDone = ({ done, userInfo }) => {
  const { expiry, membership, paymentMethod } = userInfo
  console.log(membership)
  if (done === `success`) {
    if (paymentMethod === `end_paypal_subscription`) {

      return <div className="paymentPending">
        <h4>年間支払の自動更新をキャンセルしました</h4>
        <p>メンバーシップの有効期限は {expiry} となっております。継続をご希望の場合は、期限1ヶ月前より更新が可能となっております。</p>
        <p><small>※ 会員資格失効(期限切れ)した後、3ヶ月更新がない場合は登録データは自動で削除されます。</small></p>
      </div>
    } else if (paymentMethod === `paypal_subscription`) {
      return <div className="paymentSuccess">
        <h4>PayPalでの支払いが完了しました</h4>
        <p>メンバーシップの有効期限は {expiry} となっておりますが、有効期限が自動更新（PayPal自動引落）されます。メンバーシップは会員画面より停止できます。</p>
        <p>今回、セブ日本人会より<strong>お支払いに関する詳細を記載した自動メール</strong>をお送りしております。<br />
          なお、セブ日本人会からの「登録」や「自動更新のお知らせ」などの<strong>重要なメールが、迷惑メールフォルダに振り分けられる場合</strong>がございますので、ご確認をお願いいたします。</p>
      </div>
    } else {
      return <div className="paymentSuccess">
        <h4>PayPalでの支払いが完了しました</h4>
        <p>メンバーシップの有効期限は {expiry} となっております。継続をご希望の場合は、期限1ヶ月前より再入会が可能です。</p>
        <p>今回、セブ日本人会より<strong>お支払いに関する詳細を記載した自動メール</strong>をお送りしております。<br />
          なお、セブ日本人会からの「登録」や「自動更新のお知らせ」などの<strong>重要なメールが、迷惑メールフォルダに振り分けられる場合</strong>がございますので、ご確認をお願いいたします。</p>
        <p><small>※ 会員資格失効(期限切れ)した後、3ヶ月更新がない場合は登録データは自動で削除されます。</small></p>
      </div>
    }
  } else if (done === `failed`) {
    return <div className="paymentFailed">
      <h4>PayPalでの支払いに失敗しました</h4>
      <p></p>
    </div>
  }
  return <></>
}
